export const chiudiRichiestaServizioEnte = [
  '',
  `mutation ChiudiRichiestaServizioEnte($idRichiestaEnte: Int!, $txNote: String!) {
    ChiudiRichiestaServizioEnte(idRichiestaEnte: $idRichiestaEnte, txNote: $txNote)
  }`,
];
